import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from "react";
import { Tag } from "./components";
import * as S from "./tags.style";
var Tags = function(param) {
    var _tags = param.tags, tags = _tags === void 0 ? [] : _tags, toggleTags = param.toggleTags, variant = param.variant, type = param.type;
    if (tags.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(S.Ul, {
        children: Children.toArray(tags.map(function(item) {
            return /*#__PURE__*/ _jsx(Tag, {
                type: type,
                variant: variant,
                isSelected: item.isSelected,
                onClick: toggleTags,
                children: item.label
            });
        }))
    });
};
export default Tags;
